export const currencyBasedOnRegion = {
  'AD': { code: 'EUR' },   // 🇦🇩 Andorra
  'AL': { code: 'ALL' },   // 🇦🇱 Albania
  'AT': { code: 'EUR' },   // 🇦🇹 Austria
  'BA': { code: 'BAM' },   // 🇧🇦 Bosnia and Herzegovina
  'BE': { code: 'EUR' },   // 🇧🇪 Belgium
  'BG': { code: 'BGN' },   // 🇧🇬 Bulgaria
  'BY': { code: 'BYN' },   // 🇧🇾 Belarus
  'CH': { code: 'CHF' },   // 🇨🇭 Switzerland
  'CY': { code: 'EUR' },   // 🇨🇾 Cyprus
  'CZ': { code: 'CZK' },   // 🇨🇿 Czech Republic
  'DE': { code: 'EUR' },   // 🇩🇪 Germany
  'DEU': { code: 'EUR' },  // 🇩🇪 Germany (ISO Alpha-3)
  'DK': { code: 'DKK' },   // 🇩🇰 Denmark
  'EE': { code: 'EUR' },   // 🇪🇪 Estonia
  'ES': { code: 'EUR' },   // 🇪🇸 Spain
  'ESP': { code: 'EUR' },  // 🇪🇸 Spain (ISO Alpha-3)
  'FI': { code: 'EUR' },   // 🇫🇮 Finland
  'FR': { code: 'EUR' },   // 🇫🇷 France
  'FRA': { code: 'EUR' },  // 🇫🇷 France (ISO Alpha-3)
  'GB': { code: 'GBP' },   // 🇬🇧 United Kingdom
  'GBR': { code: 'GBP' },  // 🇬🇧 United Kingdom (ISO Alpha-3)
  'GR': { code: 'EUR' },   // 🇬🇷 Greece
  'HR': { code: 'EUR' },   // 🇭🇷 Croatia
  'HU': { code: 'HUF' },   // 🇭🇺 Hungary
  'IE': { code: 'EUR' },   // 🇮🇪 Ireland
  'IS': { code: 'ISK' },   // 🇮🇸 Iceland
  'IT': { code: 'EUR' },   // 🇮🇹 Italy
  'ITA': { code: 'EUR' },  // 🇮🇹 Italy (ISO Alpha-3)
  'LI': { code: 'CHF' },   // 🇱🇮 Liechtenstein
  'LT': { code: 'EUR' },   // 🇱🇹 Lithuania
  'LU': { code: 'EUR' },   // 🇱🇺 Luxembourg
  'LV': { code: 'EUR' },   // 🇱🇻 Latvia
  'MC': { code: 'EUR' },   // 🇲🇨 Monaco
  'MD': { code: 'MDL' },   // 🇲🇩 Moldova
  'ME': { code: 'EUR' },   // 🇲🇪 Montenegro
  'MK': { code: 'MKD' },   // 🇲🇰 North Macedonia
  'MT': { code: 'EUR' },   // 🇲🇹 Malta
  'NL': { code: 'EUR' },   // 🇳🇱 Netherlands
  'NO': { code: 'NOK' },   // 🇳🇴 Norway
  'PL': { code: 'PLN' },   // 🇵🇱 Poland
  'PT': { code: 'EUR' },   // 🇵🇹 Portugal
  'PRT': { code: 'EUR' },  // 🇵🇹 Portugal (ISO Alpha-3)
  'RO': { code: 'RON' },   // 🇷🇴 Romania
  'RS': { code: 'RSD' },   // 🇷🇸 Serbia
  'RU': { code: 'RUB' },   // 🇷🇺 Russia
  'SE': { code: 'SEK' },   // 🇸🇪 Sweden
  'SI': { code: 'EUR' },   // 🇸🇮 Slovenia
  'SK': { code: 'EUR' },   // 🇸🇰 Slovakia
  'SM': { code: 'EUR' },   // 🇸🇲 San Marino
  'UA': { code: 'UAH' },   // 🇺🇦 Ukraine
  'VA': { code: 'EUR' },   // 🇻🇦 Vatican City
}

export type TypeValidRegionKey = keyof typeof currencyBasedOnRegion

type TypeCurrencyFormatter = {
  price: number,
  langCountry?: string,
  decimals?: number,
  round?: boolean,
  trailingZeros?: boolean
}

const isValidCountryRegionKey = (key: string): key is TypeValidRegionKey => {
  return key in currencyBasedOnRegion
}

export const currencyFormatter = ({ price, langCountry = 'es-ES', decimals = 2, round = true, trailingZeros = false }: TypeCurrencyFormatter) => {
  const country = langCountry?.split('-')?.[1]
  const digits = (!round && price % 1 !== 0) ? decimals : trailingZeros ? decimals : 0

  const countryKey = country.toUpperCase()
  const currency = isValidCountryRegionKey(countryKey) ? currencyBasedOnRegion[countryKey].code : 'EUR'

  return new Intl.NumberFormat(langCountry, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(round ? Math.round(price) : price)
}
